import React from "react";
import { TableInput, ImgInput } from "components/common/input";
import { PrimayDropdown } from "components/common/dropdown";
import type { IBlogList } from "service/interface/blog";
import { BlogCategory } from "service/constant/serviceConstant";
import moment from "moment";

interface Props {
  data: IBlogList;
  setData: React.Dispatch<React.SetStateAction<IBlogList>>;
}

export function BlogInfoTable({ data, setData }: Props) {
  const handleTypeDropdown = (id: number) => {
    setData((prev) => ({
      ...prev,
      type: id,
    }));
  };

  const handleTitleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({
      ...prev,
      title: e.target.value,
    }));
  };

  const handleLinkInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({
      ...prev,
      link: e.target.value,
    }));
  };

  return (
    <div>
      <div className="mb-[24px] flex items-center justify-between">
        <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
          계정 정보
        </p>
      </div>
      <div className="w-full border-t-[2px] border-t-black p-0">
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            카테고리
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <PrimayDropdown
              menuList={[
                ...Object.entries(BlogCategory).map(([key, value]) => ({
                  id: Number(key),
                  name: value,
                })),
              ]}
              label="카테고리"
              selectMenu={BlogCategory[data.type]}
              onClick={handleTypeDropdown}
            />
          </div>
        </div>
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            제목
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <TableInput
              value={data.title}
              onChange={handleTitleInput}
              placeholder="제목을 입력해 주세요"
            />
          </div>
        </div>
        {data.createdAt && (
          <div className="flex h-[58px] w-full border-b-[1px] border-b-gray-1">
            <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
              생성일
            </div>
            <div className="flex h-full w-[787px] items-center px-[24px] text-M3 text-gray-5">
              {moment(data.createdAt).format("YYYY-MM-DD")}
            </div>
          </div>
        )}
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            링크
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <TableInput
              value={data.link}
              onChange={handleLinkInput}
              placeholder="링크를 입력해 주세요(ex: http://)"
            />
          </div>
        </div>
        <div className="flex h-[272px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            이미지 등록
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <ImgInput data={data} setData={setData} name="imgSrc" />
          </div>
        </div>
      </div>
    </div>
  );
}
